import { Sparkles, Wrench, ShieldCheck, Star, Clock, User } from "lucide-react";

/** Color / icon per room state. Deterministic. */
export function roomVisuals(r) {
  const active = r.active_task;
  const state = active?.state;

  if (r.operational_status === "out_of_order" || r.operational_status === "out_of_service") {
    return { color: "#6b7280", accent: "#374151", label: "OOO", Icon: Wrench };
  }
  if (r.is_vip) {
    return { color: "#c084fc", accent: "#7c3aed", label: "VIP", Icon: Star };
  }
  if (state === "in_progress" || state === "paused") {
    return { color: "#f59e0b", accent: "#b45309", label: "Cleaning", Icon: Sparkles };
  }
  if (state === "pending_inspection") {
    return { color: "#38bdf8", accent: "#0369a1", label: "Inspection", Icon: ShieldCheck };
  }
  if (r.current_status === "available" || r.current_status === "vacant_clean") {
    return { color: "#10b981", accent: "#047857", label: "Ready", Icon: null };
  }
  if (r.current_status === "vacant_dirty") {
    return { color: "#ef4444", accent: "#991b1b", label: "Dirty", Icon: null };
  }
  return { color: "#64748b", accent: "#334155", label: r.current_status || "—", Icon: null };
}

export default function RoomCard({ room, onClick, small = false }) {
  const v = roomVisuals(room);
  const Icon = v.Icon;
  const overdue = room.active_task?.overdue;
  return (
    <button
      onClick={() => onClick?.(room)}
      data-testid={`room-${room.room_number}`}
      className={`relative group text-left rounded-xl border transition-all overflow-hidden hover:scale-[1.03] hover:z-10 ${overdue ? "ring-2 ring-red-500 shadow-[0_0_20px_rgba(244,63,94,0.35)]" : ""}`}
      style={{
        borderColor: v.accent,
        background: `linear-gradient(135deg, ${v.color}22 0%, ${v.accent}44 100%)`,
        minWidth: small ? 68 : 92, minHeight: small ? 60 : 80,
      }}
    >
      <div className="absolute inset-0 pointer-events-none" style={{ background: `radial-gradient(circle at 100% 0%, ${v.color}55, transparent 60%)` }}/>
      <div className="relative p-2 flex flex-col justify-between h-full">
        <div className="flex items-center justify-between">
          <span className={`font-display font-bold text-white ${small ? "text-[13px]" : "text-[15px]"} tabular-nums leading-none`}>
            {room.room_number || "—"}
          </span>
          {Icon && <Icon className={`w-3 h-3`} style={{ color: v.color }} strokeWidth={2.2}/>}
        </div>
        <div className="mt-1">
          <div className="text-[9.5px] uppercase tracking-wider font-semibold" style={{ color: v.color }}>
            {v.label}
          </div>
          {room.active_task?.attendant_name && !small && (
            <div className="text-[10px] text-white/70 truncate mt-0.5 flex items-center gap-1">
              <User className="w-2.5 h-2.5"/>{room.active_task.attendant_name.split(" ")[0]}
            </div>
          )}
          {room.active_task?.timer_min != null && !small && (
            <div className="text-[10px] text-white/80 mt-0.5 flex items-center gap-1 tabular-nums">
              <Clock className="w-2.5 h-2.5"/>{Math.round(room.active_task.timer_min)}m
            </div>
          )}
        </div>
      </div>
    </button>
  );
}
